import { createAction } from '@reduxjs/toolkit';
import { NatalChartBlockValue } from '../entities';

export const updateNatalChartBlockValues = createAction<NatalChartBlockValue[]>(
  'content/UPDATE_NATAL_CHART_BLOCK_VALUES',
);
